//GeneratorFlag:[NoChange]
import StaticContent from './static-content';

export default {StaticContent}
export{StaticContent}